import React from "react";
import { InsQueryStatedElement } from "../base/insQueryStatedElement";
import "@blk/aladdin-web-components/dist/collection/styles/simple-table.scss";
import { InsChartSettings } from "../chart/base/insChartSettings";
import { useCurrentWidget, useWidgetCurrentGranularity } from "../hooks/use-current-widget";
import { getCustomTableColDefs } from "./get-table-col-defs";
import { InsTable } from "./insTable";
import { getDateQuarter } from "common/date-utils";
import { isEmpty } from "common/object-helper";
import { InsWidget, InsWidgetTitle } from "components";
import { useGetSelectedCurrency } from "components/workspaces/hooks/use-current-dashboard";
import { getLeafValue, isAmount } from "hooks/widget-data/datapoints-api/helper";
import { useGetDatapointsWidgetData } from "hooks/widget-data/use-datapoints";
import { DataGranularity } from "store/current-dashboard/types";
const getKey = (key, timePeriod = DataGranularity.quarterly) => {
    const keyDate = Date.parse(key);
    if (!timePeriod || isNaN(keyDate)) {
        return key;
    }
    const date = new Date(keyDate);
    if (timePeriod === DataGranularity.quarterly) {
        return `Q${getDateQuarter(date)} ${date.getFullYear()}`;
    }
    return date.getFullYear().toString();
};
const getTableRows = (tableColumns, timeperiodSetting, rowsLimit) => (series) => {
    const resultObj = {};
    tableColumns.forEach((column) => {
        const response = series?.map((x) => ({ key: x.date, value: x.measures[column.value || ""] }))?.filter((x) => x.value || x.value === 0);
        if (!response || response.length === 0) {
            return;
        }
        const mutableCopyOfData = [...response];
        mutableCopyOfData.forEach((dataEl) => {
            const { key, value } = dataEl;
            if (!key) {
                return;
            }
            if (!resultObj[key]) {
                resultObj[key] = { key: getKey(key, timeperiodSetting), originalKey: key };
            }
            if (isAmount(value)) {
                resultObj[key][column.name] = value;
            }
            else {
                resultObj[key][column.name] = getLeafValue(value);
            }
        });
    });
    const resultArray = Object.values(resultObj);
    resultArray.sort((a, b) => {
        if (a.originalKey === b.originalKey) {
            return 0;
        }
        const aDate = Date.parse(a.originalKey), bDate = Date.parse(b.originalKey);
        if (isNaN(aDate) || isNaN(bDate)) {
            return a.originalKey > b.originalKey ? 1 : -1;
        }
        return aDate > bDate ? 1 : -1;
    });
    return resultArray
        .slice(-1 * (rowsLimit ?? 0));
};
export const InsCustomTableWidget = (props) => {
    const { sectionId, widgetId } = props, currency = useGetSelectedCurrency(), timePeriod = useWidgetCurrentGranularity(sectionId, widgetId), widget = useCurrentWidget(sectionId, widgetId), { tableColumns, tableClassName, keysCountLimit, userSettings, transposedMode } = widget?.componentProps;
    const [[result], queryState] = useGetDatapointsWidgetData(props);
    const rowData = getTableRows(tableColumns, timePeriod, keysCountLimit)(result?.data);
    const colDefs = getCustomTableColDefs(tableColumns);
    const content = React.createElement(InsQueryStatedElement, { widgetFactoryProps: props, queryState: queryState, hasData: Boolean(rowData?.length > 0) },
        React.createElement(InsTable, { className: tableClassName, columnDefs: colDefs, currency: currency, transposed: transposedMode, rowData: rowData }));
    return React.createElement(InsWidget, { sectionId: sectionId, widgetId: widgetId, showMaximize: false, content: content, footer: React.createElement(React.Fragment, null), settingsContent: !isEmpty(userSettings) && widgetId && sectionId
            ? React.createElement(InsChartSettings, { widgetId: widgetId, sectionId: sectionId, index: 0 })
            : undefined, title: React.createElement(InsWidgetTitle, { ...props }) });
};
